import { render, staticRenderFns } from "./LineItemsEditor.vue?vue&type=template&id=4bdbbc5f&scoped=true"
import script from "./LineItemsEditor.vue?vue&type=script&lang=js"
export * from "./LineItemsEditor.vue?vue&type=script&lang=js"
import style0 from "./LineItemsEditor.vue?vue&type=style&index=0&id=4bdbbc5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbbc5f",
  null
  
)

export default component.exports